import { Box, useTheme } from '@mui/material'
import React, { PropsWithChildren, useContext } from 'react'
import { Controller } from 'react-hook-form'
import { MvTypography } from '@/components/atoms/mv-typography'
import { FieldContext } from '../constants'
import { FieldControllerContext } from '../stores/context'
import { FieldInputControllerProps } from '../types/Field.types'
import { FieldTextEditor } from './FieldTextEditor'

export const FieldTextEditorController: React.FC<PropsWithChildren<FieldInputControllerProps>> = ({
  controller,
  errors,
  children
}) => {
  const theme = useTheme()
  const { isRequired, name, error, helperText, ...otherProps } = useContext(FieldContext)

  const fieldControllerContextValue = { errors }

  return (
    <FieldControllerContext.Provider value={fieldControllerContextValue}>
      <Controller
        name={name || ''}
        control={controller}
        render={({ field: { name, onChange, value, ...rest }, fieldState }) => {
          const fieldError = fieldState.invalid
          const fieldHelperText = errors && errors[name]?.message

          const handleChange = (newValue: string) => {
            onChange(newValue)
          }

          return (
            <Box
              sx={{
                maxWidth: '100%',
                overflowX: 'visible'
              }}
            >
              <FieldTextEditor
                value={value}
                onChange={handleChange}
                fieldError={fieldError}
                fieldHelperText={fieldHelperText}
                {...rest}
              >
                {children}
              </FieldTextEditor>
              {(error || fieldHelperText || helperText) && (
                <MvTypography
                  size='HELPER_TEXT_MD'
                  color={fieldError ? theme.colorToken.text.danger.normal : theme.colorToken.text.neutral.subtlest}
                  mt={'4px'}
                >
                  {helperText || fieldHelperText}
                </MvTypography>
              )}
            </Box>
          )
        }}
      />
    </FieldControllerContext.Provider>
  )
}
